import { useEffect, useState } from 'react';
import { RequestState } from '../../@types/RequestState';
import { Cars, SearchIndex } from './SearchModels';

const useVehicle = (
  url: string,
  qf?: string,
  disabled?: boolean
): [
  SearchIndex<Cars> | undefined,
  RequestState,
  undefined | (() => void),
  (vehicle: SearchIndex<Cars>) => void,
] => {
  const [cars, setCars] = useState<SearchIndex<Cars>>();
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (qf !== undefined && !disabled) {
      onFetch();
    }
  }, [qf, disabled]);

  const onFetch = async (concat?: boolean) => {
    try {
      setIsLoading(true);
      setIsError(false);
      setIsSuccess(false);
      if (concat) {
        setIsLoadingMore(true);
      }

      const urlSearchParams = new URLSearchParams(
        concat ? cars?.documentList.pagination.nextPage?.query || '' : qf || 'hits=30'
      );
      const response = await fetch(`${url}?${urlSearchParams}`);
      const result = (await response.json()) as SearchIndex<Cars>;

      if (concat && cars) {
        const nextResult: SearchIndex<Cars> = {
          ...result,
          documentList: {
            ...result.documentList,
            documents: [...cars.documentList.documents, ...result.documentList.documents],
          },
        };
        setCars(nextResult);
      } else {
        setCars(result);
      }
      setIsSuccess(true);
    } catch (_e) {
      setIsError(true);
    } finally {
      setIsLoading(false);
      setIsLoadingMore(false);
    }
  };

  const onLoadMore = () => {
    onFetch(true);
  };

  const _onLoadMore = cars?.documentList.pagination.nextPage?.query ? onLoadMore : undefined;

  return [
    cars,
    {
      isLoading,
      isLoadingMore,
      isSuccess,
      isError,
    },
    _onLoadMore,
    setCars,
  ];
};

export default useVehicle;
